import Button from "@mui/material/Button"

const TraxxButton = ({ text, onClick, style, type, disabled }) => {
  return <Button variant="contained" size="small" onClick={onClick} sx={style} type={type} disabled={disabled}>{ text }</Button>
}

export default TraxxButton;